require('./_config')

global.jQuery = require('jquery')
global.$ = jQuery

const $ = require('../../node_modules/jquery/dist/jquery.min')

const mobileMenu = require('./_mobilemenu')
const slick = require('./_slick')
const matchHeight = require('./_matchHeight')
const hider = require('./_hider')
const collage = require('./_collage')
const imagefilter = require('./_imagefilter')
const slider = require('./_slider')
const sectionmenu = require('./_sectionmenu')
const header = require('./_header')
const menu = require('./_menu')
const dropdown = require('./_dropdown')
const expander = require('./_expander')
const pagemenu = require('./_pagemenu')
const accordion = require('./_accordion')
const commonaccordion = require('./_commonaccordion')
const popup = require('./_popup')
const datepicker = require('./_datepicker')
const select = require('./_select')
const formselect = require('./_formselect')
const gallery = require('./_gallery')
const masonry = require('./_masonry')
const greeter = require('./_greeter')
const login = require('./_login')
const validate = require('./_validate')
// const salesTeaser = require('./_salesTeaser')
const truncate = require('./_truncate')
const noticebar = require('./_noticebar')
const overlay = require('./_overlay')

$(() => {
  mobileMenu.init()
  menu.init()
  slick.init()
  matchHeight.init()
  hider.init()
  collage.init()
  imagefilter.init()
  slider.init()
  sectionmenu.init()
  header.init()
  dropdown.init()
  expander.init()
  pagemenu.init()
  accordion.init()
  commonaccordion.init()
  popup.init()
  datepicker.init()
  select.init()
  formselect.init()
  gallery.init()
  masonry.init()
  greeter.init()
  login.init()
  validate.init()
  // salesTeaser.init()
  truncate.init()
  noticebar.init()
  overlay.init()
})
